'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useIsBrowser from 'hooks/useIsBrowser';
import AdvancedSearchNext from '../advanced-search-next';
const AdvancedSearchAdapter = props => {
  const $ = _c(3);
  const isBrowser = useIsBrowser();
  if (!isBrowser) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== props) {
    t0 = <AdvancedSearchNext {...props} />;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default AdvancedSearchAdapter;